import { ImageElement, PapyrusComponent } from "../types";
import { degreesToRadians } from "../util/math";

export const Image: PapyrusComponent<Omit<ImageElement, "type">> = (props) => {
    const rotation = props.rotation || 0;
    const angleInRadians = degreesToRadians(rotation);
    const rotC = Math.cos(angleInRadians);
    const rotS = -Math.sin(angleInRadians);

    return (
        <g mask={props.stepName || props.productOverlay ? undefined : props.mask}>
            <g
                transform={`
                matrix(1, 0, 0, 1, ${props.x}, ${props.y})
                matrix(1, 0, 0, 1, ${props.width / 2}, ${props.height / 2})
                matrix(${rotC}, ${-rotS}, ${rotS}, ${rotC}, 0, 0)
                matrix(1, 0, 0, 1, ${-props.width / 2}, ${-props.height / 2})
                `}
            >
                <image
                    xlinkHref={props.src}
                    preserveAspectRatio={props.preserveAspectRatio}
                    width={props.width}
                    height={props.height}
                />
            </g>
        </g>
    );
};
